module.exports = __webpack_public_path__ + "img/1.74893913.png";